import { PatientFormComponent } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingComponents'

export default function EditPatientForm({
  selectedPatient,
  setSelectedPatient,
  selectedPatientChangesDisabled,
  selectedPatientInputDataValidations,
  clinicBrandData,
  importedFromItems,
  clinicId,
  clinicBrandId,
  patientSearchApiSignature,
}) {
  return (
    <PatientFormComponent
      disablePatientSearch
      editMode={!selectedPatientChangesDisabled}
      patientDetails={selectedPatient}
      setPatientDetails={setSelectedPatient}
      hidePatientNumber={true}
      hideInputValidations={false}
      patientInputDataValidations={selectedPatientInputDataValidations}
      makeAnonymousPatient={false}
      onFindingExistingPatient={() => {}} // No-op for edit mode
      addRelatedPatient={null} // Not needed for edit mode
      clinicId={clinicId}
      clinicBrandId={clinicBrandId}
      setMakeAnonymousPatient={() => {}} // No-op for edit mode
      importIdFieldLabel={
        importedFromItems?.find(
          (item) =>
            item?.id === clinicBrandData?.patientFormSettings?.currentlySetPatientImportIdType,
        )?.title
      }
      isAllowedToAddImportId={clinicBrandData?.patientFormSettings?.exposePatientImportIdForm}
      isAllowedToAddUHID={clinicBrandData?.patientFormSettings?.exposePatientUhIdForm}
      moveEmailToMoreSettings={clinicBrandData?.patientFormSettings?.hideEmailInTheForm}
      patientSearchApiSignature={patientSearchApiSignature}
    />
  )
}
